/**
 * Created by mykurisu on 2017/8/21.
 */
import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import LecturerListItem from './LecturerListItem'
import {InfiniteScroll} from '../../components'
import {
	ListTitle,
} from '../../components/lecturerInvite/index'
class LecturerListHistory extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      searchId: "",
    };
  }

  // 监听needRefresh变化,为true重新请求数据
  componentDidUpdate(prevProps) {
    if (this.props.needRefresh) {
      this.fetchLecturers(true);
      this.props.dispatch({
        type: "LECTURER_NEED_REFRESH",
        payload: false,
      });
    }
  }

  handleSearch = (value) => {
    // 只允许输入数字
    const numericValue = value.replace(/[^\d]/g, "");

    // 如果新值和当前值相同，不执行任何操作
    if (numericValue === this.state.searchId) {
      return;
    }

    this.setState({ searchId: numericValue }, () => {
      this.fetchLecturers(true);
      this.props.dispatch({
        type: "LECTURER_INVITE_SEARCH_ID",
        payload: numericValue,
      });
    });
  };

  handleClear = () => {
    this.setState({ searchId: "" }, () => {
      this.fetchLecturers(true);
      this.props.dispatch({
        type: "LECTURER_INVITE_SEARCH_ID",
        payload: "",
      });
    });
  };

  fetchLecturers = (isSearch = false) => {
    this.setState({
      loading: true,
    });
    const { urlData } = this.props;
    const params = {
      offset: isSearch ? 0 : this.props.current.next_offset,
    };

    if (this.state.searchId) {
      params.search_id = this.state.searchId;
    }
    axios
      .get(`/api/lecture/${urlData.target_id}/lecturer/list`, { params })
      .then((res) => {
        if (res.data.code === 0) {
          this.setState({
            loading: false,
          });
          let oldlist = isSearch ? [] : this.props.currentList;
          let list = oldlist.concat(res.data.data.not_imported_lecturers);
          let selectedList = list
            .filter((item) => {
              return item.is_imported === true;
            })
            .concat(res.data.data.is_imported_lecturers);

          this.props.dispatch({
            type: "LECTURER_INVITE_INIT",
            payload: res.data.data,
          });
          this.props.dispatch({
            type: "LECTURER_INVITE_APPEND",
            payload: list,
          });
          this.props.dispatch({
            type: "LECTURER_SELECTED_LIST",
            payload: selectedList,
          });
          this.props.dispatch({
            type: "LECTURER_NEED_REFRESH",
            payload: false,
          });
          if (!this.state.searchId) {
            this.props.dispatch({
              type: "LECTURER_INVITE_ORIGIN",
              payload: res.data.data.not_imported_lecturers,
            });
          }
        }
      })
      .catch((error) => {
        console.error("数据获取失败:", error);
        this.setState({ loading: false });
      });
  };

  handelLoadMore() {
    this.fetchLecturers();
  }

  render() {
    const { currentList, current, originalList } = this.props;

    return (
      <div className="lecturer-invite-list">
        {
          <div>
            {((originalList && originalList.length > 0) ||
              (currentList && currentList.length > 0)) && (
              <div
                className={`search-container ${
                  this.props.isSearchFixed ? "search-container-fixed" : ""
                }`}
              >
								<ListTitle title={"历史嘉宾"} type={'history'}/>
                <div className="search-container-inner">
                  <div className="search-container-inner-content">
                    <div className="search-container-inner-content-input">
                      <input
                        className="search-input"
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        placeholder="请输入讲师ID"
                        onChange={(e) => this.handleSearch(e.target.value)}
                        value={this.state.searchId}
                      />
                      {this.state.searchId && (
                        <span
                          className="search-clear"
                          onClick={this.handleClear}
                        >
                          ×
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
						{
							this.state.loading && (
								<div className="lecturer-loading-container">
									<div className="lecturer-loading-spinner"></div>
									<div className="lecturer-loading-text">加载中...</div>
								</div>
							)
						}
            { currentList && currentList.length > 0 ? (
              <div style={{ paddingTop: "8px" }}>
                <InfiniteScroll
                  onTouchBottom={() => this.handelLoadMore()}
                  isStop={this.state.loading}
                  distance={50}
                  isKill={!current.has_more}
                />
                {currentList.map((item, index) => (
                  <LecturerListItem
                    type={"history"}
                    key={index}
                    content={item}
                  />
                ))}
              </div>
            ) : (
              this.state.searchId && (
                <div className="search-no-result">暂无搜索结果</div>
              )
            )}
          </div>
        }
      </div>
    );
  }
}

export default connect((state) => ({
  current: state.lecturerInvite.current,
  currentList: state.lecturerInvite.currentList,
  originalList: state.lecturerInvite.originalList,
  urlData: state.lecturerInvite.urlData,
  needRefresh: state.lecturerInvite.needRefresh,
}))(LecturerListHistory)



// WEBPACK FOOTER //
// ./src/components/lecturerInvite/LecturerListHistory.js